import { jsPDF } from 'jspdf';

import { CuripodElement, CuripodText } from '../../components/SlideComponents/slateUtil';
import { LINE_HEIGHT_FACTOR } from './constants';
import renderBulletList from './renderBulletList';
import { renderMathToImage } from './renderMath';
import renderNumberedList from './renderNumberedList';
import renderParagraph from './renderParagraph';

export type FontStyle = 'Normal' | 'Bold' | 'Italic' | 'BoldItalic';
export type Alignment = 'left' | 'right' | 'center';

type RenderTextElementProps = {
  pdf: jsPDF;
  x: number;
  y: number;
  width: number;
  textElements: CuripodElement[];
  defaultAlignment?: Alignment;
  scale?: number;
};

const renderTextElement = async ({
  pdf,
  x,
  y,
  width,
  textElements,
  scale = 1,
}: RenderTextElementProps) => {
  let currentY = y;
  for (const eachTextElement of textElements) {
    if (!eachTextElement?.size) continue;
    pdf.saveGraphicsState();
    const pdfFontSize = eachTextElement.size * scale;
    pdf.setLineHeightFactor(LINE_HEIGHT_FACTOR);
    pdf.setFontSize(pdfFontSize);
    if (eachTextElement.type === 'paragraph') {
      const { updatedY } = await renderParagraph({
        pdf,
        x,
        y: currentY,
        width,
        paraElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else if (eachTextElement.type === 'bulleted-list') {
      const { updatedY } = await renderBulletList({
        pdf,
        x,
        y: currentY,
        width,
        bulletListElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else if (eachTextElement.type === 'numbered-list') {
      const { updatedY } = await renderNumberedList({
        pdf,
        x,
        y: currentY,
        width,
        numberedListElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else if (
      eachTextElement.type === 'math-block' ||
      eachTextElement.type === 'math-inline'
    ) {
      const color =
        (eachTextElement.children?.[0] as CuripodText | undefined)?.color || undefined;
      const mathImage = await renderMathToImage(eachTextElement.value || '', {
        displayMode: eachTextElement.type === 'math-block',
        fontSize: pdfFontSize,
        color,
      });
      if (mathImage) {
        const imgX = x + (width - mathImage.width) / 2;
        pdf.addImage(
          mathImage.dataUrl,
          'PNG',
          imgX,
          currentY,
          mathImage.width,
          mathImage.height,
          undefined,
          'FAST',
        );
        currentY += mathImage.height + 4;
      }
    } else {
      //console.debug(`Unknown element type - "${eachTextElement.type}"`);
    }
    pdf.restoreGraphicsState();
  }
};

export default renderTextElement;
